import styles from "./AdminItem.module.css";
import PropTypes from "prop-types";
import Button from "shared/Button";

/**
 *
 * Displays information about a group in a group list.
 */

export function AdminItem({ adminInfo, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.item}>{adminInfo.adminName}</div>
      <div className={styles.item}>{adminInfo.iboNum}</div>
      <div className={styles.item}>{adminInfo.accessLevel}</div>

      <div className={styles.item}>
        <Button className={styles.removeBtn} onClick={onClick} size="small">
          Remove
        </Button>
      </div>
    </div>
  );
}

AdminItem.propTypes = {
  adminInfo: PropTypes.object,
  onClick: PropTypes.func,
};
